import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppComponent } from "./app.component";
import { HeaderModule } from "./layouts/header/header.module";
import { FooterModule } from "./layouts/footer/footer.module";
import { BannerModule } from "./layouts/banner/banner.module";
import { NewsModule } from "./components/news/news.module";
import { NewsService } from "./services/news.service";
import { HttpClientModule } from "@angular/common/http";
import { RouterModule, Routes } from "@angular/router";
import { IndexComponent } from "./pages/index/index.component";
import { IndexModule } from "./pages/index/index.module";
import { NoticiaComponent } from "./pages/noticia/noticia.component";
import { NoticiaModule } from "./pages/noticia/noticia.module";
import { AgmCoreModule } from "@agm/core";
import { AgmSnazzyInfoWindowModule } from "@agm/snazzy-info-window";
import { ContentComponent } from "./pages/content/content.component";
import { ContentModule } from "./pages/content/content.module";
import { MoreNewsComponent } from "./components/more-news/more-news.component";
import { MoreNewsModule } from "./components/more-news/more-news.module";
import { NglModule } from "ng-lightning";
import {
  DxPopupModule,
  DxButtonModule,
  DxTemplateModule
} from "devextreme-angular";
import { VideosComponentComponent } from "./components/videos-component/videos-component.component";
import { VideosComponentModule } from "./components/videos-component/videos-component.module";
import { SafePipe } from "./pipes/safe.pipe";
import { ContactoComponent } from "./layouts/contacto/contacto.component";
import { ContactoModule } from "./layouts/contacto/contacto.module";
import { FaqComponent } from "./layouts/faq/faq.component";
import { FaqModule } from "./layouts/faq/faq.module";
import { FrmDenunciaComponent } from "./layouts/frm-denuncia/frm-denuncia.component";
import { FrmDenunciaModule } from "./layouts/frm-denuncia/frm-denuncia.module";
import { FrmSugerenciaComponent } from "./layouts/frm-sugerencia/frm-sugerencia.component";
import { FrmSolicitudComponent } from "./layouts/frm-solicitud/frm-solicitud.component";
import { FrmSugerenciaModule } from "./layouts/frm-sugerencia/frm-sugerencia.module";
import { FrmSolicitudModule } from "./layouts/frm-solicitud/frm-solicitud.module";
import { RegistroComponent } from "./components/registro/registro.component";
import { RegistroModule } from "./components/registro/registro.module";
import { ChartsComponent } from "./components/charts/charts.component";
import { ChartsModule } from "./components/charts/charts.module";
import { DeviceDetectorModule } from "ngx-device-detector";
import { ChartComponent } from "./components/chart/chart.component";
import { ChartModule } from "./components/chart/chart.module";
import { CovidComponent } from './pages/covid/covid.component';
import { CovidModule } from './pages/covid/covid.module';
import { ReportComponent } from './pages/report/report.component';
import { ReportModule } from "./pages/report/report.module";
import { RegistroRendicionComponent } from "./components/registro-rendicion/registro-rendicion.component";
import { RegistroRendicionModule } from "./components/registro-rendicion/registro-rendicion.module";
import { NgxCaptchaModule } from "ngx-captcha";
import { NoticiasmoComponent } from './pages/noticiasmo/noticiasmo.component';
import { NoticiasmoModule } from "./pages/noticiasmo/noticiasmo.module";


const appRoutes: Routes = [
  { path: "index", component: IndexComponent },
  { path: "noticia/:id", component: NoticiaComponent },
  { path: "noticiasmo/:id", component: NoticiasmoComponent },
  { path: "content/:id", component: ContentComponent },
  { path: "noticias", component: MoreNewsComponent },
  { path: "videos", component: VideosComponentComponent },
  { path: "contactenos", component: ContactoComponent },
  { path: "faq", component: FaqComponent },
  { path: "formulario-denuncia", component: FrmDenunciaComponent },
  { path: "formulario-sugerencia", component: FrmSugerenciaComponent },
  { path: "formulario-solicitud", component: FrmSolicitudComponent },
  { path: "seguimiento", component: ReportComponent },
  { path: "manualprevencioncovid", component: CovidComponent },
  //{ path: "test-charts123456", component: ChartComponent },
  { path: "registro-rendicion", component: RegistroRendicionComponent },
  { path: "", redirectTo: "index", pathMatch: "full" }
];

@NgModule({
  declarations: [AppComponent],
  imports: [
    NglModule.forRoot(),
    BrowserModule,
    ContactoModule,
    FaqModule,
    HeaderModule,
    FooterModule,
    BannerModule,
    NewsModule,
    HttpClientModule,
    IndexModule,
    NoticiaModule,
    CovidModule,
    ContentModule,
    MoreNewsModule,
    VideosComponentModule,
    FrmDenunciaModule,
    FrmSugerenciaModule,
    RegistroModule,
    FrmSolicitudModule,
    ChartsModule,
    ChartModule,
    ReportModule,
    DxPopupModule,
    DxButtonModule,
    DxTemplateModule,
    NgxCaptchaModule,
    RegistroRendicionModule,
    NoticiasmoModule,
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false } // <-- debugging purposes only
    ),
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyCNmvnO0-5IF3egVvgXbgnasd14LM_gF0E"
    }),
    AgmSnazzyInfoWindowModule
  ],
  providers: [NewsService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts